class ExternalAppInterface {

  init() {
    this.messageId = 0;
    this.initFlutterInterface();
    this.initWebInterface();
  }

  initFlutterInterface() {
    let extAppInt = this;

    window.appToJs = (message) => {
      extAppInt.handleMessageFromFlutter(message);
    };
  }

  initWebInterface() {
    let extAppInt = this;

    window.addEventListener('message', (event) => {
      extAppInt.handleMessageFromWeb(event);
    });
  }

  async handleMessageFromFlutter(message) {
    let reply = await this.processMessage(message, 'flutter');
    if (!reply) return;

/*
    if (window.jsToApp) {
      window.jsToApp.postMessage(JSON.stringify(reply));
    }
*/
    if (window.flutter_inappwebview &&
      typeof window.flutter_inappwebview.callHandler === 'function') {
      window.flutter_inappwebview.callHandler('jsToApp', JSON.stringify(reply));
    }
  }

  notifyToFlutter(message) {
/*
    if (window.jsToApp) {
      window.jsToApp.postMessage(JSON.stringify(message));
    }
*/
    if (window.flutter_inappwebview &&
      typeof window.flutter_inappwebview.callHandler === 'function') {
      window.flutter_inappwebview.callHandler('jsToApp', JSON.stringify(message));
    }
  }

  async handleMessageFromWeb(event) {
    let reply = await this.processMessage(event.data, 'web');
    if (reply) {
      event.source.postMessage(reply, event.origin);
    }
  }

  notifyToWeb(message) {
    console.log("sending message to web = " + JSON.stringify(message));
    if (window.opener) {
      window.opener.postMessage(message, "");
    }
  }

  async processMessage(message, origin) {
    if (!message) return undefined;

    console.log("processMessage: message = " + JSON.stringify(message) + ", origin = " + origin);

    if (message.messageType === 'back') {
      let result = await this.back(message.body);
      if (result) {
        return {
          messageId: message.messageId,
          messageType: 'backReply',
          userData: message.userData,
          body: result,
        };
      }
      else {
        return {
          messageId: message.messageId,
          messageType: 'backReply',
          userData: message.userData,
          body: { resultCode: 'ERROR' },
        };
      }
    }
    else if (message.messageType === 'createTemporaryIdentity') {
      let result = await this.createTemporaryIdentity(message.body);
      if (result) {
        return {
          messageId: message.messageId,
          messageType: 'createTemporaryIdentityReply',
          userData: message.userData,
          body: result,
        };
      }
      else {
        return {
          messageId: message.messageId,
          messageType: 'createTemporaryIdentityReply',
          userData: message.userData,
          body: { resultCode: 'ERROR' }
        };
      }
    }
    else if (message.messageType === 'saveContent') {
      let result = await this.saveContent(message.body);
      if (result) {
        return {
          messageId: message.messageId,
          messageType: 'saveContentReply',
          userData: message.userData,
          body: result,
        };
      }
      else {
        return {
          messageId: message.messageId,
          messageType: 'saveContentReply',
          userData: message.userData,
          body: { resultCode: 'ERROR' }
        };
      }
    }
    else if (message.messageType === 'getContentStatus') {
      let result = await this.getContentStatus(message.body);
      if (result) {
        return {
          messageId: message.messageId,
          messageType: 'getContentStatusReply',
          userData: message.userData,
          body: result
        };
      }
      else {
        return {
          messageId: message.messageId,
          messageType: 'getContentStatusReply',
          userData: message.userData,
          body: { resultCode: 'ERROR' }
        };
      }
    }
  }

  async back(params) {
    //TODO
  }

  async createTemporaryIdentity(params) {
    if (global.content) {
      return await global.content.createTemporaryIdentity();
    }
  }

  async saveContent(params) {
    if (global.content) {
      return await global.content.save(params.isTemporary, params.extInfo,
        params.extInfoResources);
    }
  }

  async getContentStatus(params) {
    if (global.content) {
      return await global.content.getStatus();
    }
  }

  notifyEvent(e) {
    let message = {
      messageId: this.messageId++,
      messageType: 'notifyEvent',
      body: e
    };

    this.notifyToFlutter(message);
    this.notifyToWeb(message);
  }
}

export default ExternalAppInterface;
